class QuickBuyModal extends window.BAO.CustomElement() {
  connectedCallback () {
    if (!this.validate()) return
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(document.documentElement, 'click', this.handleTrigger)

    this.externalEls?.trigger?.elements?.forEach(triggerEl => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })
    this.els?.close?.elements?.forEach(close => {
      this.listeners.add(close, `click`, this.handleClose)
    })
  }

  validate () {
    if (!this.externalEls?.trigger?.exists) {
      console.warn('QuickBuyModal: Missing trigger element')
      return false
    }
    return true
  }

  handleTrigger (e) {
    const searchResultsContainer = document.querySelector(
      '.kuQuickSearchResultsContainer',
    )

    if (searchResultsContainer) {
      const displayStyle = window.getComputedStyle(searchResultsContainer)
        .display

      if (displayStyle !== 'none') {
        e.stopPropagation()
      }
    }

    this.triggerEl = e.target.closest(
      `[data-quick-buy-modal-external-el="trigger"]`,
    )

    if (!this.triggerEl) return

    if (this.triggerEl.dataset.siteModalKey !== this.dataset.siteModalKey) {
      return
    }

    document.body.classList.toggle('util-SiteOverflowed', true)
    this.setAttribute('aria-hidden', 'false')
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }
}

if (!customElements.get('quick-buy-modal')) {
  customElements.define('quick-buy-modal', QuickBuyModal)
}

class QuickBuyModalForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    if (this.formEl.dataset.zakekeProduct === 'true') {
      this.handleZakekeProduct = this.handleZakekeProduct.bind(this)
      this.listeners.add(this.submitBtnEl, 'click', this.handleZakekeProduct)
    } else {
      // Product form handles the add to cart - we dont need to fire it twice
      // Just close the modal.
      this.closeModal = this.closeModal.bind(this)
      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
        this.closeModal,
      )
    }
  }

  closeModal (et) {
    this.modalEl?.handleClose()

    const cartEvent = new CustomEvent('quickBuy:added')

    document.dispatchEvent(cartEvent)
  }

  handleZakekeProduct (evt) {
    evt.preventDefault()
    evt.stopPropagation()

    const pid = this.formEl.querySelector('input[name="zakeke-product-id"]')
      .value

    const originalAction = this.formEl.action
    this.formEl.action = `${window.zakekeUrl || '/apps/zakeke'}?pid=${pid}`

    window.onpageshow = function (event) {
      if (event.persisted) {
        this.formEl.action = originalAction
      }
    }

    this.formEl.submit()
  }

  get modalEl () {
    return this.externalEls?.modal?.element
  }

  get formEl () {
    return this.els?.form?.element
  }

  get submitBtnEl () {
    return this.els?.button?.element
  }

  get optionChoicesEl () {
    return this.containerEl?.querySelector(
      '[data-product-variant-dropdown-external-el="option-choice"]',
    )
  }

  get containerEl () {
    return this.closest(
      '[data-product-variant-dropdown-external-el="container"]',
    )
  }
}

if (!customElements.get('quick-buy-modal-form')) {
  customElements.define('quick-buy-modal-form', QuickBuyModalForm)
}
